import { jsx as _jsx } from "react/jsx-runtime";
import { isDefined } from '@showroomjs/core';
import * as React from 'react';
import { createNameContext } from './create-named-context';
const IsClientContext = createNameContext('IsClient', undefined);
export const IsClientContextProvider = (props) => {
    const [isClient, setIsClient] = React.useState(false);
    React.useEffect(() => {
        setIsClient(true);
    }, []);
    return (_jsx(IsClientContext.Provider, { value: isClient, children: props.children }));
};
export const useIsClient = () => {
    const isClient = React.useContext(IsClientContext);
    if (!isDefined(isClient)) {
        throw new Error('useIsClient must be used within IsClientContextProvider!');
    }
    return isClient;
};
//# sourceMappingURL=use-is-client.js.map